import React from 'react';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function DiasUteisAdd({ setOption }) {
  return (
    <ContainerSection>
      <h3>Incluir</h3>
      <div>
        <WrapperInputsNewSystem>
          <InputDate title="Data" id="Data" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="* Descrição" id="Descricao" widthPercentage="100%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions title="Tipo" id="Tipo" optionsArray={['', 'Fixo', 'Móvel']} widthPercentage="45%" />
          <SelectAndOptions
            title="Abrangência"
            id="Abrangencia"
            optionsArray={['', 'Nacional', 'Estadual', 'Municipal']}
            widthPercentage="45%"
          />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="País"
            id="Pais"
            optionsArray={['', 'BRASIL', 'EUA', 'CANADA', 'CHINA', 'RUSSIA', 'ESPANHA', 'JAPÃO', 'KOREIA DO SUL']}
            widthPercentage="45%"
          />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="UF"
            id="UF"
            optionsArray={[
              '',
              'AC',
              'AL',
              'AP',
              'AM',
              'BA',
              'CE',
              'DF',
              'ES',
              'GO',
              'MA',
              'MT',
              'MS',
              'MG',
              'PA',
              'PB',
              'PR',
              'PE',
              'PI',
              'RJ',
              'RN',
              'RS',
              'RO',
              'RR',
              'SC',
              'SP',
              'SE',
              'TO',
            ]}
            widthPercentage="45%"
          />
          <SelectAndOptions title="Município" id="Municipio" optionsArray={['', 'Outros']} widthPercentage="45%" />
        </WrapperInputsNewSystem>
      </div>
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
    </ContainerSection>
  );
}
